import React from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info'; // Icon for instructions

/**
 * Reusable component to display a list of instructions or notes for a form.
 * * @param {Array<string>} instructions - An array of strings, where each string is a single instruction/note.
 * @param {string} title - Optional title for the instruction box.
 */
export default function FormInstructionBox({ instructions = [], title = "Important Notes" }) {
  if (instructions.length === 0) {
    return null; // Don't render if there are no instructions
  }

  return (
    <Box
      sx={{
        p: 2,
        mt: 5,
        mb: 3,
        border: '1px solid #6dd5ed', // Light blue border for attention
        borderRadius: 2,
        backgroundColor: 'rgba(109, 213, 237, 0.1)', // Very light blue background
      }}
    >
      <Typography variant="h6" component="h3" sx={{ mb: 1, color: '#2193b0' }}>
        <ListItemIcon sx={{ minWidth: 35, display: 'inline-flex', verticalAlign: 'middle', color: '#2193b0' }}>
            <InfoIcon fontSize="small" />
        </ListItemIcon>
        **{title}**
      </Typography>
      
      <List dense disablePadding>
        {instructions.map((instruction, index) => (
          <ListItem key={index} disableGutters>
            <ListItemText primary={instruction} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}